export default __webpack_public_path__ + "static/media/IT.9dfb44f9.jpg";